import type { List } from '@/types/common';
import type { EventSearchQueryRequest, EventSearchResponse } from '@/types/search';

export const getSearchEventsAPI = (query: EventSearchQueryRequest) => {
	return useRequest<List<EventSearchResponse>>(EVENTS_SEARCH_ENDPOINT, REQUEST_METHOD.GET, {}, query);
};